// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_nk-0";